const menu = {
  key: "items",
  route: "/legacy/items",
  label: "sidebar.items",
  icon: "faBox",
  group: "inventory",
  order: 10,
  permission: "legacy.items.access"
};

export default menu;